import React, {useEffect, useMemo, useState} from 'react'
import { useHistory } from 'react-router';

import FixedLoader from "../../../components/FixedLoader/FixedLoader";
import {TopBarRedesigned} from "../../../components/TopBarRedesigned";
import {
    Description,
    ModalButtons,
    PageWithStickyFooter,
    PageContent,
    StickyButtonContainer,
    CheckMark,
    SafetyGuidelines,
    Subtitle,
    UnpaidGap
} from "./AvailableJob.styles";
import styles from "../ShiftDetailPage/ShiftDetail.module.scss";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";

import {
    AccordionExpandIcon,
    convertDentalOfficeStatus,
} from "../ShiftDetailPage/components";
import Api, {config} from "../../../api";
import _ from "lodash";
import useActionApi from "../../../hooks/useActionApi";
import InstaBookOfferModal from "./components/InstaBookOffer";
import MakeOfferModal from "./components/MakeOffer";
import {HeaderDescription} from "../ConfirmedOfferPage/ConfirmedOffer.styles";
import {EndorsementsContainer, ShiftContainer, TitleBoxContainer} from "./components";

dayjs.extend(isToday)

export const JOB_STATUSES = {
    POSTED: 1,
    PARTIAL: 2,
    CONFIRMED: 3,
    COMPLETED: 4,
    OFFER_EXPIRED: 5
}

export const PARTIAL_OFFER_STATUS = {
    POSTED: 0,
    REJECTED: 1,
    ACCEPTED: 2,
    EXPIRED: 3,
    REMOVED: 4
}

const AvailableJobPage = () => {
    const [trackData, setTrackData] = useState<any>(null);
    const history = useHistory();
    const {jobId, job: jobData, isFavourite} = history.location.state as any
    const [job, setJob] = useState(jobData || {} as any)

    const [getJobDetailsLoading, , getJobDetails] = useActionApi({
        apiMethod: Api.getJobDetails,
        onSuccess: (jobObj: any) => {
            if(_.isEmpty(jobObj)) return
            setJob(jobObj)
        },
    });

    useEffect(() => {
        if(_.isEmpty(jobData) && jobId) {
            getJobDetails(jobId)
        }
    }, [])

    useEffect(() => {
        if (!_.isEmpty(job)) {
            setTrackData({
                isInstabookEnabled: !!job.Instabook,
                recommendedHourlyRate: job.proposedRate,
                currencyCode: job.location.country ? 'USD' : 'CAD',
                dentalOfficeLocationId: job.locationId,
                dentalOfficeId: job.dentistId,
                dentalOfficeStatus: convertDentalOfficeStatus(job.location.status),
                shiftStartDate: new Date(job.startDate.replace(/-/g, "/") + ' ' + job.shifts[0].postedStart).toISOString(),
                shiftEndDate: new Date(job.startDate.replace(/-/g, "/") + ' ' + job.shifts[0].postedEnd).toISOString(),
                shiftId: job.shifts[0].id,
                shiftPostDate: new Date(job.postedOn).toISOString(),
            })
        }
    }, [job]);

    return (<>
        <TopBarRedesigned
            title={'Shift Details'}
            onBack={() => {
                history.goBack()
            }}
        />
        {!_.isEmpty(job) ? <PageWithStickyFooter>
            <PageContent>
                <HeaderDescription>Posted On: {dayjs(job.postedOn).format('dddd, MMM D')}</HeaderDescription>

                <TitleBoxContainer job={job} />

                <ShiftContainer job={job}/>

                <EndorsementsContainer job={job} />

                <SafetyGuidelines>
                    <CheckMark/>
                    <Subtitle>
                        This office has confirmed they meet or exceed the {job.location.province} guidelines for workplace safety and
                        infection control.
                    </Subtitle>
                </SafetyGuidelines>
                {!!job.shifts[0].gapUnpaid && <UnpaidGap>This office does not pay for downtime.</UnpaidGap>}
                <AccordionExpandIcon job={job} />

            </PageContent>
            <StickyButtonContainer>
            <ModalButtons><InstaBookOfferModal job={job} history={history} trackData={trackData} isFavourite={isFavourite} /></ModalButtons>
                <Description className={styles.showDescription}>
                    ${job.proposedRate}/hr* is the proposed rate by the dental office, but you can choose your own hourly rate <a
                    href="https://support.tempstars.com/hc/en-us/articles/4410655181459-How-Does-TempStars-Manage-Hourly-Rates"
                    target="_system"
                    className={"external"}
                >learn more</a>
                </Description>
                <ModalButtons><MakeOfferModal job={job} history={history} trackData={trackData}/></ModalButtons>
            </StickyButtonContainer>

        </PageWithStickyFooter> : null}

        <FixedLoader
            loading={getJobDetailsLoading}
        />
    </>)
}

export default AvailableJobPage;
